import { createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';
import {
  AppState,
  CommercialState,
  FetchedPartnerAccessInvitation,
  PartnerAccessInvitationFormData,
} from '@store';
import { InvitationStatusType } from '@vi-iot/client';

export namespace CommercialSelectors {
  export const commercial = (state: AppState): CommercialState => state.commercial;

  export const fetchedInvitations = createSelector(
    commercial,
    (state: CommercialState): FetchedPartnerAccessInvitation[] => state.fetchedInvitations
  );

  export const isCustomerInvitationPresent = createSelector(
    commercial,
    (state: CommercialState): boolean => state.isCustomerInvitationPresent
  );

  export const invitationsToSend = createSelector(
    commercial,
    (state: CommercialState): PartnerAccessInvitationFormData[] => state.invitationsToSend
  );

  export const isFetchingInvitations = createSelector(
    commercial,
    (state: CommercialState): boolean => state.isFetchingInvitations
  );

  export function getInvitationWithIndex(
    index: number
  ): MemoizedSelector<
    AppState,
    PartnerAccessInvitationFormData,
    DefaultProjectorFn<PartnerAccessInvitationFormData>
  > {
    return createSelector(
      invitationsToSend,
      (invitations): PartnerAccessInvitationFormData | undefined => invitations[index]
    );
  }

  export const isNoInstallationToSend = createSelector(invitationsToSend, (invitations): boolean =>
    invitations.every((invitation) => invitation.responseStatus)
  );

  export function isEmailAlreadyInvited(
    email: string
  ): MemoizedSelector<AppState, boolean, DefaultProjectorFn<boolean>> {
    return createSelector(fetchedInvitations, (fetchedInvitationsArray): boolean =>
      fetchedInvitationsArray?.some(
        (invitation) =>
          invitation.inviteeEmail === email &&
          (invitation.status === InvitationStatusType.Accepted ||
            invitation.status === InvitationStatusType.Pending)
      )
    );
  }

  export function isEmailAlreadyInForm(
    email: string
  ): MemoizedSelector<AppState, boolean, DefaultProjectorFn<boolean>> {
    return createSelector(invitationsToSend, (invitationsToSendArray): boolean =>
      invitationsToSendArray.some((invitation) => invitation.inviteeEmail === email)
    );
  }
}
